import React from "react";
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import PaymentsMode from "./PaymentsMode/PaymentsMode";
import { Redirect } from 'react-router'
import { Translation } from 'react-i18next';
import renderPrice from "../../../utils/renderPrice";
// import Placeholder from "../../../images/product-placeholder.png"

class Summary extends React.Component {
  render() {
    const { cart, freeze, timeSlotId, enableProductsReplacement,
      enableReplacement, paymentMethod, setPaymentMethod, gift, setGift } = this.props;

    if (!timeSlotId) {
      return <Redirect to='/checkout' />;
    }

    return (
      <Translation>
        {t =>
          <div>
            <div className="checkout-data-title">{t("checkout.summary.title")}</div>
            <div className="checkout-summary">
              <div className="container-fluid">
                <Row className="mb-3">
                  <Col className="px-0">
                    {t("subTotal")}
                  </Col>
                  <Col className="px-0 text-right checkout-summary-total-text">
                    {cart && `\u20AC ${renderPrice(cart.netTotal.toFixed(2))}`}
                  </Col>
                </Row>
                {cart && cart.fees && cart.fees.map(fee => (
                  <Row className="mb-3" key={fee.id}>
                    <div className="col-8 px-0">
                      {fee.description}
                    </div>
                    <div className="col-4 px-0 text-right checkout-summary-total-text">
                      {cart && `\u20AC ${renderPrice(fee.value.toFixed(2))}`}
                    </div>
                  </Row>
                ))}
                <Row className="pt-3 mb-3 checkout-summary-total">
                  <Col className="px-0">
                    {t("total")}*
                  </Col>
                  <Col className="px-0 text-right">
                    {cart && cart.totalToPay ? `\u20AC ${renderPrice(cart.totalToPay.toFixed(2))}` : `\u20AC ${renderPrice(cart.netTotal.toFixed(2))}`}
                  </Col>
                </Row>
              </div>
            </div>

            {/* <div className="checkout-subtitle">
              {t("summary.rating")}
            </div> */}

            {/* <div style={{ marginBottom: "33px" }} className="checkout-data-title">
              {t("checkout.gift")}
            </div>

            <div className="d-flex mt-3 ">
              <div className="radio-button mr-3" style={{ maxWidth: "250px" }}>
                <div className="custom-control custom-radio">
                  <input type="radio" className="custom-control-input"
                    id="POINTS"
                    name="POINTS"
                    value="POINTS"
                    checked={gift === "POINTS"}
                    onChange={() => setGift("POINTS")}
                  />
                  <label className="custom-control-label" htmlFor="POINTS">
                    {t("checkout.points")}
                  </label>
                </div>
              </div>
              <div className="radio-button" style={{ maxWidth: "250px" }}>
                <div className="custom-control custom-radio">
                  <input type="radio" className="custom-control-input"
                    id="WATER"
                    name="WATER"
                    value="WATER"
                    checked={gift === "WATER"}
                    onChange={() => setGift("WATER")}
                    disabled
                  />
                  <label className="custom-control-label" htmlFor="WATER">
                    {t("checkout.water")}
                  </label>
                </div>
              </div>
            </div> */}

            <hr />

            <div className="d-flex">
              <div className="radio-button">
                <div className="custom-control custom-checkbox">
                  <input type="checkbox" className="custom-control-input"
                    id="isDisableReplacement"
                    name="isDisableReplacement"
                    checked={enableProductsReplacement}
                    onChange={() => enableReplacement(!enableProductsReplacement)}
                  />
                  <label className="custom-control-label" style={{ fontSize: "16px"}} htmlFor="isDisableReplacement">
                    {t("summary.checkoutTitle")}*
                  </label>
                </div>
              </div>
            </div>

            <hr />

            <PaymentsMode
              cart={cart}
              paymentMethod={paymentMethod}
              setPaymentMethod={setPaymentMethod}
            />

            <div className="text-center">
              <button
                disabled={paymentMethod === null || enableProductsReplacement === false}
                style={{ width: "293px" }}
                className="cta"
                onClick={() => freeze(cart.id)}
              >
                <span>{t("summary.orderConclusion")}</span>
              </button>
            </div>

          </div>
        }
      </Translation>
    )
  }
}

export default Summary


